export default __webpack_public_path__ + "img/fwMZpOdl.043e7cbe.svg";